import { Box, Flex, Text } from '@opendoor/bricks/core';
import imgixUrl from '@opendoor/bricks/helpers/imgixUrl';

const ExclusivesOverview = () => {
  return (
    <Flex
      flexDirection="column"
      gridGap={4}
      height="calc(100dvh - 224px)"
      textAlign="left"
      maxWidth={['100%', null, '560px']}
    >
      <Box display="grid" gap="20px" gridTemplateColumns="32px 1fr">
        <CheckRow title="Answer questions about your home" active>
          <Text size="120" pb="5">
            Takes a few minutes
          </Text>
        </CheckRow>
        <CheckRow title="Review your cash offer estimate from Opendoor" afterActive />
        <CheckRow title="Get potential higher offers from additional buyers" last afterActive />
      </Box>
    </Flex>
  );
};

export default ExclusivesOverview;

function CheckRow({
  children,
  active,
  afterActive,
  last,
  title,
}: {
  children?: React.ReactNode;
  active?: boolean;
  afterActive?: boolean;
  last?: boolean;
  title: React.ReactNode;
}) {
  const baseProps = { zIndex: 0 };
  const stateProps = {
    alt: 'incomplete',
    src: afterActive
      ? imgixUrl('2023-09-1695049245314-09189.svg')
      : imgixUrl('2023-07-1690385139277-63410.svg'),
  };
  const sizeProps = active ? { height: 32, width: 32 } : { height: 16, width: 16 };

  return (
    <>
      <Box pos="relative" textAlign="center" w="100%" zIndex={0}>
        {/* eslint-disable-next-line @opendoor/no-html-elements, jsx-a11y/alt-text -- Image not updating src correctly and alt is set in stateProps */}
        <img {...baseProps} {...stateProps} {...sizeProps} />

        {!last && (
          <Box
            bgColor={active || afterActive ? 'warmgrey300' : 'warmgrey950'}
            bottom="-36px"
            left="15px"
            pos="absolute"
            top="8px"
            w="2px"
            zIndex={-1}
          />
        )}
      </Box>
      <Box>
        {active ? (
          <Text as="h3" fontWeight="medium" pb="0" mt="0" mb="4" size="150">
            {title}
          </Text>
        ) : (
          <Text as="h3" color="warmgrey800" size="120" pt={['1px', null, 0]} mt="0" mb="2">
            {title}
          </Text>
        )}
        {active && children}
      </Box>
    </>
  );
}
